<template>
  <div class="page-content">

    <section
      class="
        page-action
      "
      style="
        margin-bottom: 0;
      ">
      <div class="content-wrap">
        <el-button
          type="info"
          icon="
            el-icon-arrow-left
          "
          size="small"
          round
          @click="
            () => fallback()
          ">
          ย้อนกลับ
        </el-button>
      </div>
    </section>

    <section
      class="
        content-wrap
      "
      style="
        margin: 0 auto;
      ">
      <div
        class="
          action-panel
        ">
        <div panel="main">
          <div>
            <b>
              {{ name || 'ชื่อนามสกุล' }}
            </b>
            <p>
              {{ toMobileNo(user.mobileNo) || 'เบอร์มือถือ' }}
            </p>
          </div>
        </div>
        <hr/>
        <div panel="action">
          <el-button
            type="sc-asset"
            icon="
              el-icon-edit
            "
            @click="
              () => editor.open = true
            ">
            แก้ไข
          </el-button>
        </div>
      </div>
    </section>

    <section
      class="
        content-wrap
      ">
      <div>
        <b>
          รายการสถานะ
        </b>
        <p>
          พบ <b>{{ items.length }}</b> รายการ
        </p>
      </div>
      <div
        v-if="
          items.length == 0
        "
        class="empty">
        <img
          src="@/assets/images/admin/empty.png"
        />
        <p>
          <b class="unknown">
            ไม่พบข้อมูล
          </b>
        </p>
      </div>
      <div
        v-if="
          items.length > 0
        "
        class="role-list">
        <div
          v-for="
            (item, i) in items
          "
          :key="i"
          class="item">
          <div
            class="
              item-content
            ">
            <div class="item-icon">
              <img
                :src="
                  item.projectIcon
                "
                @error="
                  event => imgError(event)
                "
              />
            </div>
            <div class="item-detail">
              <b>
                {{ item.role }}
              </b>
              <p
                class="
                  subtitle ellipsis
                ">
                บ้านเลขที่ {{ item.addressNo }} - โครงการ{{ item.projectName }}
              </p>
            </div>
          </div>
          <el-button
            type="danger"
            icon="
              el-icon-s-release
            "
            @click="
              () => remove(
                'remove-role', item
              )
            ">
            ลบสถานะ
          </el-button>
        </div>
      </div>
    </section>
  
    <NonScUserEditor
      :mode="
        'update-user'
      "
      :open="
        editor.open
      "
      :form="
        editor.form
      "
      @update-user="
        value => updateUser(value)
      "
      @remove-user="
        () => remove(
          'remove-user', user
        )
      "
      @closed="
        () => editor.open = false
      "
    />
    
    <NonScAlert
      :open="
        confirm.open
      "
      :type="
        'error'
      "
      :head="
        confirm.head
      "
      :message="
        confirm.message
      "
      :cancel="true"
      @confirm="
        () => call(confirm.action)
      "
      @closed="
        () => confirm.open = false
      "
    />

    <!-- Loader -->
    <div 
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)">
    </div>
  </div>
</template>

<script lang="js">

// Components
import NonScUserEditor from './NonScUserEditor.vue'
import NonScAlert from '../../components/NonScAlert.vue'

// Common
import {
  NonScCommon as Common
} from '../../common/nonsc.common'

import {
  NonScUserCommon as UserCommon
} from '../../common/nonsc-user.common'

// Services
import { NonScFeature } from '../../feature'

export default {
  components: {
    NonScAlert,
    NonScUserEditor,
  },
  data() {
    
    // Init Title
    const title = 'รายละเอียดลูกบ้าน'

    // Init Loader
    const loader = false

    // Init User
    const user = {
      id        : null,
      firstName : null,
      lastName  : null,
      mobileNo  : null,
      email     : null,
      role      : []
    }

    // Editor State
    const editor = {
      open: false,
      form: (
        Object.assign({}, UserCommon.input)
      )
    }

    // Init Alert
    const alert = {
      open    : false,
      type    : 'error',
      message : null,
    }
    
    // Init Remove
    const confirm = {
      open    : false,
      head    : 'ลบข้อมูล',
      message : null,
      action  : null
    }

    return {
      title,
      loader,
      user,
      editor,
      alert,
      confirm
    }
  },
  computed: {
    clientUser() {
      return NonScFeature.user
    },
    clientRole() {
      return NonScFeature.role
    },
    userId() {
      return this.$route.params.userId
    },
    name() {

      // User Props
      const {
        firstName, lastName
      } = this.user

      // Set Name
      if (firstName && lastName) {
        return `${firstName} ${lastName}`
      } 
    },
    items() {

      // User Props
      const { role } = this.user

      // Item Mapper
      const toItem = (value) => {

        // Default Result
        const result = {
          id          : null,
          role        : null,
          addressNo   : null,
          projectIcon : null,
          projectName : null,
          projectCode : null,
        }

        // Home Props
        const {
          id, code, home, project
        } = value

        // Set Home ID
        if (id) result.id = id

        // Set Role
        const role = (
          Common.setRole(code)
        )

        // Set Role Name
        if (role) {
          result.role = role.name
        }

        // Set Address
        if (home) {
          result.addressNo = home.addressNo
        }

        // Set Project 
        if (project) {

          // Project Props
          const {
            name: projectName,
            code: projectCode,
            icon: projectIcon
          } = project

          // Set Project
          Object.assign(
            result, {
              projectName, projectCode, projectIcon
            }
          )
        }

        return result
      }

      return role.map(toItem)
    }
  },
  watch: {
    'editor.open'(open) {
      
      // Validate State
      if (!open) return

      // Set Editor Form
      Object.assign(
        this.editor.form, this.setForm(this.user)
      )
    }
  },
  mounted() {
    
    // Init Title
    this.$emit(
      'sub-title', this.title
    )

    // Validate User ID
    if (!this.userId) this.fallback()

    // Fetch User
    this.fetchUser()
  },
  methods: {
    imgError(e) {
      e.target.src = 'https://www.scasset.com/images/sca-orange.svg'
    },
    toMobileNo(input) {
      return Common.toMobileNo(input)
    },
    setForm(value) {

      // Default Value
      const result = {
        firstName : null,
        lastName  : null,
        mobileNo  : null,
        email     : null,
      }
      
      // Validate Value
      if (!value) return result

      // Form Keys
      const key = Object.keys(result)

      // Set Form
      key.forEach(
        e => result[e] = value[e]
      )

      // Set Mobile Number
      result.mobileNo = (
        this.toMobileNo(result.mobileNo)
      )

      return result
    },
    call(action) {
      if (typeof action =='function') action()
    },
    async fetchUser() {
      
      // Loading
      this.loader = true

      try {
        
        // Validate User ID
        if (!this.userId) {
          throw new Error('INVALID_PARAMS')
        }

        // Fetch User
        const result = (
          await this.clientUser.get(this.userId)
        )

        // Set User
        if (result) {
          Object.assign(this.user, result)
        }
      }
      catch (_) {
        this.fallback()
      }
      finally {
        setTimeout(
          () => this.loader = false, 400
        )
      }
    },
    async updateUser(value) {
      
      // Loading
      this.loader = true

      try {
        
        // Validate User ID
        if (!value) {
          throw new Error('INVALID_PARAMS')
        }

        // Fetch User
        await this.clientUser.update(
          this.userId, this.setForm(value)
        )
      }
      catch (error) {
        this.notify(
          Common.error(error)
        )
      }
      finally {
        await this.fetchUser()
      }
    },
    remove(mode, value) {

      // Validate User
      if (!value || !value.id) return

      switch(mode) {
        
        // Remove Role Handler
        case 'remove-role': {

          // Role Props
          const { id, role } = value
          
          // Confirm Heading
          this.confirm.message = (
            `ต้องการลบสถานะ ${role}?`
          )

          // Confirm Action
          this.confirm.action = (
            () => this.removeRole(id)
          )
        }
        break
        
        // Remove User Handler
        case 'remove-user': {
          
          // User Props
          const { id, firstName } = value
          
          // Confirm Heading
          this.confirm.message = (
            `ต้องการลบข้อมูลลูกบ้าน ${firstName}?`
          )

          // Confirm Action
          this.confirm.action = (
            () => this.removeUser(id)
          )
        }
        break
      }

      // Open Confirm
      setTimeout(
        () => this.confirm.open = true, 100
      )
    },
    async removeRole(roleId) {
      
      // Loading
      this.loader = true

      try {
        
        // Validate Role ID
        if (!roleId) {
          throw new Error('INVALID_PARAMS')
        }
        
        // Request Remove Role
        await this.clientRole.remove(roleId)
      }
      catch (error) {
        this.notify(
          Common.error(error)
        )
      }
      finally {
        await this.fetchUser()
      }
    },
    async removeUser() {
      
      // Loading
      this.loader = true

      try {
        
        // Validate User ID
        if (!this.userId) {
          throw new Error('INVALID_PARAMS')
        }

        // Request Remove User
        await this.clientUser.remove(this.userId)

        // Fallback Route
        this.fallback()
      }
      catch (error) {
        this.notify(
          Common.error(error)
        )
      }
      finally {
        setTimeout(
          () => this.loader = false, 400
        )
      }
    },
    notify(message) {

      // Validate Message
      if (!message) return
      
      // Set Notice
      const notice = () => (
        Object.assign(
          this.alert, { open: true, message }
        )
      )

      // Set Alert
      setTimeout(notice, 400)
    },
    fallback() {
      this.$router.push({
        name: 'nonsc-user-list'
      })
    }
  }
}
</script>
<style lang="css" scoped>

.content-wrap {
  display     : grid;
  gap         : var(--size-sm);
  background  : white;
}

section {
  flex-direction: column;
}

.action-panel hr {
  display: none;
}

.role-list {
  display : grid;
  gap     : var(--size-sm);
}

.item {
  padding     : var(--size-sm);
  gap         : var(--size-sm);
  overflow    : hidden;
  align-items : center;
}

.item-content {
  flex        : 1;
  display     : flex;
  align-items : center;
  gap         : var(--size-sm);
  overflow    : hidden;
}

.item-icon {
  flex: none;  
}
.item-detail {
  flex      : 1;
  overflow  : hidden;
}

.item-icon img {
  width         : 4rem;
  aspect-ratio  : 1/1;
  object-fit    : cover;
  border-radius : var(--size-xs);
}

@media screen and (max-width: 1024px) {

  .action-panel hr {
    display: block;
  }
  
  .role-list {
    grid-template-columns: 1fr;
  }
}

</style>


// WEBPACK FOOTER //
// src/features/nonsc/pages/user/NonScUserDetail.vue